<div>
  <!-- Print / Close Buttons -->
  <div style="margin-left: 70%; margin-bottom: 2%">
    <button printSectionId="print-section" mat-raised-button color="primary" ngxPrint [useExistingCss]="true"
      class="noPrint">
      Print
    </button>
    <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
  </div>

  <!-- Print Section -->
  <div id="print-section">
    <div class="container">
      <!-- <div class="row">
        <div class="col-12" style="background-color: black;color: white;text-align: center;">
          <span class="fontBold">
            TAX ORDER
          </span>
        </div>
      </div> -->

      <!-- Header -->
      <div class="row">
        <div class="col-9 topheader">
          <span class="fontBold">हिंदुस्थान प्रकाशन संस्था</span>
          <span><span class="heading1">साप्ताहिक विवेक - पुस्तक विभाग</span></span>
          <span>मुख्य कार्यालय: 5/12, कामत औद्योगिक वसाहत, 396 स्वा. वीर सावरकर मार्ग, प्रभादेवी, मुंबई-25.</span>
          <span>प्रशासकीय कार्यालय: 116-119, पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग, वडाळा मुंबई - 400031.</span>
          <span>दूरध्वनी: ९९६७५७०५३१ | Email: vivekbookdept&#64;gmail.com</span>
        </div>
        <div class="col-3 flex">
          <img src="../../../assets/img/brand/book.png"style="width:70%;" alt="Logo" class="logo-img" />
        </div>
      </div>

      <!-- GST & PAN -->
      <div class="row">
        <div class="col-6">
          <b>GSTIN/Unique Id :</b> 27AAATH0433Q1ZI
        </div>
        <div class="col-6">
          <b>PAN No. :</b> AAATH0433Q
        </div>
      </div>

      <!-- TAX ORDER No & Date -->
      <div class="row">
        <div class="col-6">
          <b>Order No. :</b> {{ this.bookinvoice[0]["oder_no"] }}
        </div>
        <div class="col-6">
          <b>Order Date :</b> {{ this.bookinvoice[0]["booking_date"] | date: 'dd-MM-yyyy' }}
        </div>
      </div>

      <!-- Receiver & Consignee -->
      <div class="row">
        <div class="col-6">
          <h3><b>Details of Receiver :</b></h3>
          <span class="receiver"><b>Name :</b> {{ this.bookinvoice[0]["receiver_name"] }}</span>
          <span class="receiver"><b>Address :</b>
            {{ this.bookinvoice[0]["addresss"] }},
            {{ this.bookinvoice[0]["taluka"] }},
            {{ this.bookinvoice[0]["district"] }},
            {{ this.bookinvoice[0]["state"] }},
            {{ this.bookinvoice[0]["country"] }},
            {{ this.bookinvoice[0]["pincode"] }}
          </span>
          <span class="receiver"><b>Phone :</b> {{ this.bookinvoice[0]["mobile_no"] }}</span>
          <span class="receiver"><b>GSTIN :</b> {{ this.bookinvoice[0]["gst"] }}</span>
        </div>
        <div class="col-6">
          <h3><b>Details of Consignee :</b></h3>
          <span class="receiver">Name :</span>
          <span class="receiver">Address :</span>
          <span class="receiver">Phone :</span>
          <span class="receiver">GSTIN :</span>
        </div>
      </div>

      <!-- Table Header -->
      <div class="row">
        <div class="col-1 tableDescheader">S.No</div>
        <div class="col-3 tableDescheader">Book Name</div>
        <div class="col-1 tableDescheader">HSN Code</div>
        <div class="col-1 tableDescheader">Book Price</div>
        <div class="col-1 tableDescheader">Sale Price</div>
        <div class="col-1 tableDescheader">Discount Amount</div>
        <div class="col-1 tableDescheader">Net Amount</div>
        <div class="col-1 tableDescheader">Book Copies</div>
        <div class="col-2 tableDescheader">Total Taxable Value</div>
      </div>

      <!-- Table Rows -->
      <div class="row" *ngFor="let item of this.bookinvoicedata; let i = index">
        <div class="col-1 tableDesc">{{ i + 1 }}</div>
        <div class="col-3 tableDesc" style="text-align: left;">{{ item["book_name"] }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">4902</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item["book_price"] }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item["book_sale_price"]}}</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ (item['discountamt'] || 0) | number:'1.2-2' }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item["totalafterdiscount"] }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item["book_copies"] }}</div>
        <div class="col-2 tableDesc" style="text-align: right;">{{ item["total"] }}</div>
      </div>

      <!-- Total & GST Section -->
      <div class="row noborderRow">

        <div class="col-8 heading1" style="border-bottom: 2px solid black;">
          <strong>Invoice Total in Words:</strong> {{ amtinwords }}
        </div>

        <div class="col-4">
          <table style="width: 100%; border-collapse: collapse; text-align: center;">
            <tr>
              <th>SGST</th>
              <th>CGST</th>
              <th>IGST</th>
              <th>Total GST</th>
            </tr>
            <tr>
              <td>{{ bookinvoice[0]?.SGST_percent }}%</td>
              <td>{{ bookinvoice[0]?.CGST_percent }}%</td>
              <td>{{ bookinvoice[0]?.IGST_percent }}%</td>
              <td><strong>{{ bookinvoice[0]?.percent }}%</strong></td>
            </tr>
            <tr>
              <td>{{ bookinvoice[0]?.SGST }}</td>
              <td>{{ bookinvoice[0]?.CGST }}</td>
              <td>{{ bookinvoice[0]?.IGST }}</td>
              <td><strong>{{ bookinvoice[0]?.gstAmount }}</strong></td>
            </tr>
          </table>
        </div>
      </div>


      <!-- Bank & Total -->
      <div class="row">
        <div class="col-8" style="display: flex; justify-content: space-between;">
          <div>
            <div><b>Bank Details:</b></div>
            <div>A/C Name - HINDUSTAN PRAKASHAN SANSTHA</div>
            <div>A/C No. - 20109800154</div>
            <div>IFSC No. - MAHB0000318</div>
            <div>Bank Name - Bank of Maharashtra</div>
            <div>Branch - Prabhadevi, Mumbai - 400025</div>
          </div>
          <div>
            <img src="../../../assets/img/brand/qr_code1.png" alt="QR Code" class="qr-code" />
          </div>
        </div>
        <div class="col-4" style="display: flex; flex-direction: column; border-bottom: 1px solid black; padding: 1px;">
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Total
              :</span><span><strong>{{ this.total_amount }}</strong></span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Shipping Charges
              :</span><span>{{ this.shipping_charges }}</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Round Off
              :</span><span>0</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Invoice Total
              :</span><span><strong>{{ this.totals }}</strong></span></div>
          <!-- <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Previous Deposit :</span><span>0</span></div> -->
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Previous Dues
              :</span><span>0</span></div>
          <div class="spacebet" style="font-weight: 500; padding: 6px 8px;"><span>Total Dues :</span><span>{{
              this.totals }}</span></div>
        </div>
      </div>

      <!-- Terms & Signature -->
      <div class="row">
        <div class="col-8 flexbox" style="padding: 15px;">
          <h2>Terms:</h2>
          <span>1) Complaints of any nature must be communicated in writing within 10 days from the date of
            delivery.</span>
          <span>2) A/C payee cheques to be drawn in favor of :-</span>
          <span>हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग</span>
        </div>
        <div class="col-4 flexadd" style="padding: 15px;">
          <span style="font-size: 1.2rem; font-weight: 700;">हिंदुस्थान प्रकाशन संस्था</span>
          <div style="height: 80px;"></div>
          <div style="text-align: center;"><span>Authorised Signatory</span></div>
        </div>
      </div>
    </div>
  </div>
</div>